var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"staking-card main-block"},[_c('p',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))]),_c('p',{staticClass:"data"},[_vm._v(_vm._s(_vm.data))]),(_vm.list.length)?_c('div',{staticClass:"ul"},_vm._l((_vm.list),function(l,key){return _c('div',{key:key,staticClass:"li"},[_c('span',[_vm._v(_vm._s(l))])])}),0):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }